import { Box, Typography } from '@mui/material';

const WidgetNoAccess = () => (
  <Box
    sx={{
      flex: 1,
      height: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    <Typography sx={{ textAlign: 'center' }}>
      You no longer have access.
      <br />
      Please upgrade to access the full table.
    </Typography>
  </Box>
);

export default WidgetNoAccess;
